import {Modal, Button} from 'components/ui';
import {useMobile} from 'utils/hooks';
import styles from './FocusModeModal.module.scss';

interface FocusModeModalProps {
  /** Blocking message to display. Pass null/undefined to hide the modal. */
  message: string | null | undefined;
  /** Called when the student clicks "Continuar" */
  onContinue: () => void;
}

/**
 * FocusModeModal
 *
 * Generic notification modal for Focus Mode blocking events.
 * Shown when the student tries to copy/paste, right-click, switch tabs
 * or navigate away from the trilha.
 *
 * Renders nothing when `message` is falsy.
 */
function FocusModeModal({
  message,
  onContinue,
}: FocusModeModalProps): JSX.Element | null {
  const {isMobile} = useMobile();

  if (!message) return null;

  return (
    <Modal
      isOpen
      onClose={onContinue}
      clickOutsideToClose={false}
      buttonClose={false}
      minWidth={isMobile ? undefined : 500}
      maxWidth={isMobile ? 360 : 500}
      vw={isMobile ? 94 : 90}
    >
      <div className={styles.container}>
        <p className={styles.message}>{message}</p>
        <div className={styles.action}>
          <Button text="Continuar" variant="primary" onClick={onContinue} />
        </div>
      </div>
    </Modal>
  );
}

export default FocusModeModal;
